export const ROUTES = {
  HOME: '/',
  // The only sign-in left on the web (app owner, by e-mail code). The two
  // legacy auth URLs still circulate in e-mails, so they redirect to /app.
  ADMIN_LOGIN: '/admin/login',
  ADMIN_SESSION: '/admin/session',
  LEGACY_LOGIN: '/login',
  LEGACY_FINISH_SIGNUP: '/finish_signup',
  ONBOARDING_QR: '/join/$slug/$token',
  ONBOARDING_QR_PRINT: '/onboarding-poster/$slug/$token',
  PROFILES: '/profiles',
  PUBLIC_PROFILE: '/p/$slug',
  COMPANIES: '/companies',
  COMPANY_DETAILS: '/bjj/$slug',
  COMPANY_STORE: '/bjj/$slug/loja',
  COMPANY_STORE_PRODUCT: '/bjj/$slug/loja/$productId',
  COMPANY_FRIDGE: '/bjj/$slug/geladeira',
  FRIDGE_QR_PRINT: '/bjj/$slug/geladeira/qrcode',
  FRIDGE_POSTER: '/bjj/$slug/geladeira/poster',
  // Served by Rails (DownloadsController): phones go straight to their store.
  DOWNLOAD: '/download',
  COMPANY_NEW: '/companies/new',
  COMPANY_LANDING: '/para-equipes',
  FACE_RECOGNITION_LANDING: '/reconhecimento-facial',
  FAQ_INDEX: '/faq',
  FAQ_PAGE: '/faq/$slug',
  GUIDE_INDEX: '/guia',
  GUIDE_PAGE: '/guia/$slug',
  PRIVACY_POLICY: '/privacidade',
  PRIVACY_POLICY_EN: '/en/privacidade',
  TERMS_OF_USE: '/termos',
  TERMS_OF_USE_EN: '/en/termos',
  ADMIN: '/admin',
  ADMIN_COMPANY: '/admin/companies/$slug',
  // Profile editing and academy management live in the native app. `/app`
  // explains that; the splat keeps every legacy `/app/*` deep link (e-mails,
  // digests, bookmarks) landing on the same explanation.
  APP_ONLY: '/app',
  APP_ONLY_LEGACY: '/app/$',
} as const;
